import { shallowEqual, useSelector } from 'react-redux';

function useSettings() {
  const settings = useSelector((store) => store.settings, shallowEqual);
  return settings;
}

export default useSettings;
